import { useEffect, useState } from 'react';

import { obterVerificacao } from 'services/verificacaoService';
import { temPendenciaDeVerificacao } from 'services/verificacaoStatus';

/**
 * A verificação de documento do usuário logado, para o aviso do dashboard.
 *
 * Espelha o usePendenciaAssinatura, inclusive no que ele engole: falha de rede é ignorada de
 * propósito, porque quem consome isto é sinalização acessória e não pode derrubar a tela em que
 * está.
 *
 * Devolve o objeto inteiro, e não um booleano, porque o aviso muda de texto conforme a situação
 * (falta enviar × foi recusada, e aí com o motivo). Quem só quer saber "tem pendência?" usa o
 * `pendente`.
 *
 * @param {boolean} habilitado — passe false para cliente, que não tem documento a enviar.
 */
export function usePendenciaVerificacao(habilitado = true) {
  const [verificacao, setVerificacao] = useState(null);

  useEffect(() => {
    if (!habilitado) {
      setVerificacao(null);
      return undefined;
    }

    let ativo = true;
    obterVerificacao()
      .then((dados) => {
        if (ativo) setVerificacao(dados);
      })
      .catch(() => { /* silencioso: sinalização acessória não pode atrapalhar a tela */ });

    return () => { ativo = false; };
  }, [habilitado]);

  return { verificacao, pendente: temPendenciaDeVerificacao(verificacao) };
}
